// ofuro-wiki: No AI feature
export const AIUsage = () => {
  return null;
};
